import { Image } from '@cian/ui-kit';
import * as React from 'react';

import moreInfo from './more-info.png';

export const MoreInfoImage: React.FC = () => {
  return <Image src={moreInfo} borderRadius={0} />;
};
